import styled from 'styled-components';
import { device } from './deviceSize';
import { size } from './deviceSize';

const Container = styled.div`
    margin: 20px 0 0 0;
    width: 60vw;
    height: 270px;
    border: 1px solid #e82764;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media ${device.mobileL} {
        width: 100%;
        height: 300px;
    }
`;

const NumberPeople = styled.span`
    color: #e82764;
    font-weight: bolder;
`;

const HowManyPeople = styled.div`
    margin-top: 20px;
    font-size: 25px;
    color: #aeacac;
`;

const Sentence = styled.div`
    margin-top: 20px;
    font-size: 30px;
    font-weight: bold;
    color: #fd5187;

    @media ${device.mobileL} {
        font-size: 20px;
    }
`;

const MessageContainer = styled.div`
    margin-top: 20px;
    /* margin: 20px 10px 0 10px; */
    color: #aeacac;
    font-size: 20px;
    text-align: center;
`;

const ButtonContainer = styled.div`
    margin-top: 30px;
`;

const ButtonSign = styled.button`
    border: none;
    padding: none;
    background-color: #e82764;
    width: 200px;
    height: 50px;
    color: white;
    font-size: 20px;
    cursor: pointer;
`;

export {
    Container,
    NumberPeople,
    HowManyPeople,
    Sentence,
    MessageContainer,
    ButtonContainer,
    ButtonSign
}